import { parseSearchParams } from '../utils/url';

export const getUuid = () => {
    const urlParams = parseSearchParams(window.location.hash);
    return urlParams.id;
};
